import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from '@env/environment';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  private loginDetails = new BehaviorSubject<any>(null); 
  private userCardDetails = new BehaviorSubject<any>(null); 
  loginDetails$ = this.loginDetails.asObservable();
  userCardDetails$ = this.userCardDetails.asObservable();
  constructor( private api: ApiService) { }
  checklogin(obj: any) {
    return this.api.getCall(environment.MOJO_URL + 'mojo/checklogin/0');
  }

  setLoginDetails(details: any) {
    this.loginDetails.next(details);
  }

  // Method to update user card details
  setUserCardDetails(details: any) {
    this.userCardDetails.next(details);
  }
    authenticate(obj: any) {
    return this.api.call(environment.MOJO_URL + 'mojo/authenticate/0', obj, 'json');
  }
    resetPassword(obj: any) {
    return this.api.call(environment.MOJO_URL + 'mojo/resetpassword', obj, 'json');
  }
   getSectionData(obj: any = {}) {
    return this.api.getCall(environment.FRAPI_URL + 'Newsalert_newsalert/getSectionData/'+ obj?.text);
  }
   checkUserExist(obj: any = {}) {
    return this.api.call(environment.FRAPI_URL + 'premium/checkUserExist', obj);
  }
   easySignup(obj: any = {}) {
    return this.api.call(environment.MOJO_URL + 'mojo/easysignup?s=nc', obj, 'json');
  }
   verifyOtp(obj: any = {}) {
    return this.api.call(environment.FRAPI_URL + 'user_otpverify/verifyOtp', obj);
  }
   generateSmsOtp(obj: any = {}, resend: number) {
    return this.api.call(environment.FRAPI_URL + `user_otpverify/generateOtp/sms/${resend}`, obj);
  }
  generateEmailOtp(obj: any = {}, resend: number) {
    return this.api.call(environment.FRAPI_URL + `user_otpverify/generateOtp/email/${resend}`, obj);
  }
}
